import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.page.html',
  styleUrls: ['./slider.page.scss'],
})
export class SliderPage implements OnInit {

  slides = [];

  constructor(public http:HttpClient, public translate:TranslateService, public toastCtrl:ToastController) {
    this.http.get<any>('https://api.blowjob.cherish.com.ua/api/get_slides').subscribe(async res => {
      if (res.error_code == 0) {
        this.slides = res.data.slides;
      } else {
        await (await (this.toastCtrl.create({message: translate.instant('UNKNOW_ERROR')}))).present();
      }
    }, async err => {
      await (await (this.toastCtrl.create({message: translate.instant('CONNECTION_ERROR'), duration:5000 }))).present();
    })
  }

  ionViewDidLeave(){
    localStorage.setItem('first','0');
  }

  ngOnInit() {
  }

}
